import { Mail, Phone } from "lucide-react";
import { NavLink } from "react-router";

const FOOTER_COLUMNS: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "Solutions",
    links: [
      { label: "Automated Customer Support", to: "/solutions/automated-customer-support" },
      { label: "Record Livestreams in HD", to: "/solutions/record-whatnot-livestreams" },
      { label: "BIN Price Calculator", to: "/tools/bin-price-calculator" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Docs", to: "/docs" },
      { label: "Blog", to: "/blog" },
    ],
  },
  {
    title: "More",
    links: [
      { label: "Pricing", to: "/pricing" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy", to: "/legal/privacy" },
      { label: "Terms", to: "/legal/terms-and-conditions" },
    ],
  },
];

export function MarketingFooter() {
  return (
    <footer className="border-t px-6 py-10" data-testid="marketing-footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 sm:flex-row sm:justify-between sm:gap-x-16">
        <div className="flex flex-col gap-3 sm:mr-4">
          <div className="flex items-center gap-2">
            <img src="/hype-stream.png" alt="HypeStream Logo" className="h-8 w-8" />
            <span className="text-xl font-bold">HypeStream</span>
          </div>
          <a
            href="tel:+15034043514"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            data-testid="footer-phone-link"
          >
            <Phone className="size-3.5" />
            +1 (503) 404-3514
          </a>
          <a
            href="mailto:hypestream.io@gmail.com"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            data-testid="footer-email-link"
          >
            <Mail className="size-3.5" />
            hypestream.io@gmail.com
          </a>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:flex sm:flex-wrap sm:gap-x-16">
          {FOOTER_COLUMNS.map((column) => (
            <div key={column.title}>
              <h3 className="mb-2 text-sm font-semibold">{column.title}</h3>
              <ul className="space-y-1">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.to.startsWith("mailto:") ? (
                      <a
                        href={link.to}
                        className="text-sm text-muted-foreground hover:text-foreground"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <NavLink
                        to={link.to}
                        className="text-sm text-muted-foreground hover:text-foreground"
                      >
                        {link.label}
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}
